export const getTypeName = (typeId, types) => {
  const found = types.find((type) => type.id == typeId);
  return found ? found.label : null;
};
